// Navbar.js

import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { FaSearch, FaTimes, FaBars, FaUser } from 'react-icons/fa';
import { MdFiberNew } from 'react-icons/md';          // NEW
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const NavBar = ({ isSidebarVisible, setIsSidebarVisible }) => {
  const navigate       = useNavigate();
  const location       = useLocation();
  const { isLoggedIn } = useAuth();

  /* ───────── STATE ───────── */
  const [isDesktop,  setIsDesktop]  = useState(window.innerWidth > 1180);
  const [searchTerm, setSearchTerm] = useState('');

  /* ───────── RESIZE LISTENER ───────── */
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1180);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* ───────── SEARCH ───────── */
  const handleSearchInput = (e) => setSearchTerm(e.target.value);

  const executeSearch = () => {
    if (searchTerm.trim()) {
      navigate(
        `/lookssearch?query=${encodeURIComponent(searchTerm.trim())}`
      );
    }
  };

  const handleSearchKeyPress = (e) => e.key === 'Enter' && executeSearch();

  /* ───────── AUTH‑GUARDED NAV ───────── */
  const handleRestrictedClick = (path) =>
    isLoggedIn ? navigate(path) : navigate('/login');

  /* ───────── RENDER HELPERS ───────── */
  const renderSearchInput = () => (
    <div className="navbar__search">
      <input
        type="text"
        className="search-input"
        placeholder="Search for Posts"
        value={searchTerm}
        onChange={handleSearchInput}
        onKeyPress={handleSearchKeyPress}
      />
      <div className="search-icons">
        {searchTerm && (
          <FaTimes
            className="clear-search-icon"
            onClick={() => setSearchTerm('')}
          />
        )}
        <FaSearch className="search-icon" onClick={executeSearch} />
      </div>
    </div>
  );

  /* ───────── JSX ───────── */
  return (
    <Container id="navbar">
      {/* ───── Mobile / Tablet ───── */}
      {!isDesktop ? (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
          {/* Hamburger */}
          <div
            className="hamburger-menu"
            onClick={() => setIsSidebarVisible(!isSidebarVisible)}
          >
            <FaBars />
          </div>

          {/* Logo */}
          <div className="hyroclipse-logo">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                if (location.pathname === '/') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  navigate('/');
                }
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/looksaway_logo.png`}
                alt="Looksaway Logo"
                className="navbar-hyroclipse-logo"
              />
            </a>
          </div>

          {renderSearchInput()}
        </div>
      ) : (
        /* ───── Desktop ───── */
        <>
          <div className="navbar-left">{renderSearchInput()}</div>

          {/* LARGE ICONS */}
          {/* NEW‑POSTS */}
          <div className="nav-icons-large">
            <MdFiberNew
              className="navbar-icon navbar-icon-newposts"
              onClick={() => {
                if (location.pathname === '/newposts') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  navigate('/newposts');
                }
              }}
            />
          </div>

          {/* RIGHT‑SIDE BUTTONS */}
          <div className="nav-icons">
            <button
              onClick={() => handleRestrictedClick('/looksmyposts')}
              className="navbar-item"
            >
              <FaUser className="navbar-icon" />
              <span className="text">My&nbsp;Posts</span>
            </button>
          </div>
        </>
      )}
    </Container>
  );
};

export default NavBar;
